export const app_yes_no_tr = {
  true: 'Evet',
  false: 'Hayır',
};
